export default __webpack_public_path__ + "static/komunal-logo-512-c8dc0949ceca07039158615e615580b9.jpg";